import {
  mockCmsFooter,
  mockCmsHeader,
  mockCmsSeoSite,
} from '@domgen/dgx-fe-cms';
import { CmsRegistrationRoot } from '../../models/cms/cms-registration-root.interface';

export const mockCmsRegistrationRoot: CmsRegistrationRoot = {
  ...mockCmsHeader,
  ...mockCmsFooter,
  ...mockCmsSeoSite,
  applianceRegistrationBenefits: [
    'registration benefit 1',
    'registration benefit 2',
  ],
  registrationProtectionBenefits: {
    item0: {
      icon: { name: 'shield-check' },
      title: 'title',
      body: 'benefit 1',
    },
  },
};
